/**
 * Mobile Portal Auth Context
 *
 * Purpose: Auth for SmartPay mobile/field ops (per PRD §6). Field ops manage
 * mobile units & ATMs; they are not NamPost/retail agents.
 * Location: mobile-portal/src/contexts/AuthContext.tsx
 */

import { createContext, useContext, useState, type ReactNode } from 'react';

interface User {
  id: string;
  name: string;
  email: string;
  role: 'field_op' | 'supervisor';
}

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>({
    id: 'field-001',
    name: 'Demo Field Op',
    email: 'fieldop@ketchupsolutions.com',
    role: 'field_op',
  });

  const login = async (_email: string, _password: string) => {
    setUser({
      id: 'field-001',
      name: 'Demo Field Op',
      email: 'fieldop@ketchupsolutions.com',
      role: 'field_op',
    });
  };

  const logout = () => {
    setUser(null);
    window.location.href = '/login';
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
